import { createApp } from "vue";
import { createPinia } from "pinia";
import { OktaAuth } from "@okta/okta-auth-js";
import App from "./App.vue";
import router from "./router";
import {
  IS_DEMO,
  OKTA_ISSUER,
  OKTA_CLIENT_ID,
  OKTA_REDIRECT_URI,
  OKTA_POST_LOGOUT_REDIRECT_URI,
} from "./utils/env";
import { setOktaAuth } from "./utils/oktaAuth";

const app = createApp(App);

app.config.errorHandler = (err, instance, info) => {
  console.error("Global error:", err);
  console.error("Error info:", info);
  console.error("Component instance:", instance);
};

app.config.warnHandler = (msg, _instance, trace) => {
  console.warn("Warning:", msg);
  console.warn("Trace:", trace);
};

app.use(createPinia());
app.use(router);

if (!IS_DEMO) {
  if (!OKTA_ISSUER || !OKTA_CLIENT_ID) {
    console.error(
      "[Auth] Okta configuration is missing. " +
        "Set VITE_OKTA_ISSUER and VITE_OKTA_CLIENT_ID, or use VITE_APP_MODE=demo for local development.",
    );
  } else {
    console.log("[Auth] Initializing Okta with configuration:");
    console.log("[Auth]   Issuer:", OKTA_ISSUER);
    console.log("[Auth]   Client ID:", OKTA_CLIENT_ID);
    console.log(
      "[Auth]   Redirect URI:",
      OKTA_REDIRECT_URI || `${globalThis.location.origin}/login/callback`,
    );
    console.log(
      "[Auth]   Post Logout Redirect URI:",
      OKTA_POST_LOGOUT_REDIRECT_URI || globalThis.location.origin,
      OKTA_POST_LOGOUT_REDIRECT_URI ? "(from env)" : "(fallback to origin)",
    );

    const oktaAuth = new OktaAuth({
      issuer: OKTA_ISSUER,
      clientId: OKTA_CLIENT_ID,
      redirectUri:
        OKTA_REDIRECT_URI || `${globalThis.location.origin}/login/callback`,
      postLogoutRedirectUri:
        OKTA_POST_LOGOUT_REDIRECT_URI || `${globalThis.location.origin}`,
      scopes: ["openid", "profile", "email"],
      pkce: true,
      // Use Vue Router for post-login navigation instead of the SDK's default
      // window.location.replace(), which would kill the Vue app mid-flight.
      restoreOriginalUri: async (_oktaAuth, originalUri) => {
        await router.replace(originalUri || "/");
      },
    });

    setOktaAuth(oktaAuth);
    oktaAuth.start();
    console.log("[Auth] Okta initialized successfully");
  }
}

app.mount("#app");
